module.exports = __webpack_public_path__ + "static/media/Light-Paws.e0fe0e89.png";